import React, { useState } from 'react';
import { Button, OverlayTrigger } from 'react-bootstrap';
import { EyeFill, EyeSlashFill } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';
import { TransportOrder } from '../../domain/transportOrder';
import { TransportOrderDetailsPopover, TransportOrderDetailsPopoverConfig } from './TransportOrderDetailsPopover';

type TransportOrderLinkWithPreviewProps = {
    transportOrder: TransportOrder;
    config?: {
        popoverConfig?: TransportOrderDetailsPopoverConfig;
    };
}

export const TransportOrderLinkWithPreview = ({ transportOrder, config }: TransportOrderLinkWithPreviewProps) => {
    const [isShown, setIsShown] = useState(false);

    const handlePopoverClose = () => {
        setIsShown(false);
    }

    const handlePopoverOpen = () => {
        setIsShown(true);
    }

    return <>
        <Link to={`/transport-orders/${transportOrder.id}`}>{transportOrder.orderId}</Link>
        <OverlayTrigger
            trigger="click"
            rootClose
            placement="bottom-start"
            show={isShown}
            onToggle={(nextShow) => setIsShown(nextShow)}
            overlay={<TransportOrderDetailsPopover
                transportOrder={transportOrder}
                onPopoverClose={handlePopoverClose}
                config={config?.popoverConfig}
            />}>
            <Button
                className="p-0 text-decoration-none text-black"
                variant="link">
                {isShown ?
                    <EyeSlashFill onClick={handlePopoverClose} className="cursor-pointer ms-2" /> :
                    <EyeFill onClick={handlePopoverOpen} className="cursor-pointer ms-2" />
                }
            </Button>
        </OverlayTrigger>
    </>;
};
